import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { CoreService } from 'app/services/entidades/core.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CustomersService extends CoreService {

  constructor(
    private _http: Http
  ) {
    super(_http);
  }

  /**
   * Servicio para crear nuevos clientes en el sistema
   * @param {Object} customer Datos del nuevo cliente
   */
  add(customer: any): Observable<any> {
    return this.postMethod('customers/', customer);
  }

  get(idcustomer: number = null): Observable<any> {
    if (idcustomer) {
      return this.getMethod(`customers/${idcustomer}`);
    } else {
      return this.getMethod('customers/');
    }
  }

  getEvents(idcustomer: number = null): Observable<any> {
    return this.getMethod(`customers/casos/${idcustomer}`);
  }

  /**
   * Servicio para actualizar un cliente del sistema
   * @param {Object} customer Datos del nuevo cliente
   */
  update(customer: any): Observable<any> {
    return this.putMethod('customers/', customer);
  }

  delete(idcusctomer: number) {
    return this.deleteMethod(`customers/${idcusctomer}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/entidades/customers.service.ts